import React from 'react'

import styled from 'styled-components'

import { SortOrder } from '../../api/generated'
import { colors } from '../../constants/colors'
import { sortingSelectors } from '../../constants/sortingSelectors'
import { breakpoints } from '../breakPoints'
import { FlexRow } from '../projectComponents'

const Block = styled(FlexRow)`
  cursor: pointer;
  margin-right: 12px;

  img {
    width: 38px;
    height: 38px;
    padding: 12px 10px;
    border-radius: 10px;
    background: ${colors.secondary};
    box-sizing: border-box;
  }

  p {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    margin-right: 15px;
  }

  @media (width < ${breakpoints.tabletMin}) {
    display: none;
  }
`

const MobileSortButton = styled.button`
  display: none;

  @media (width < ${breakpoints.tabletMin}) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: ${colors.secondary};
    cursor: pointer;

    img {
      width: 17.5px;
      height: 13.5px;
    }
  }
`

interface SortProps {
  onClickSort: () => void
  selectedSort: string
  sortOrder: SortOrder
  toggleSort: () => void
}

export const SortButton: React.FC<SortProps> = ({
  onClickSort,
  selectedSort,
  sortOrder,
  toggleSort,
}) => {
  const title = sortingSelectors.find(selector => selector.value === selectedSort)?.name

  return (
    <>
      <Block>
        <p onClick={onClickSort}>{title}</p>
        {'  '}{' '}
        <img alt={''} onClick={toggleSort} src={'/images/buttons/sort-vertical-primary.svg'} />
      </Block>
      <MobileSortButton
        aria-label={sortOrder === 'asc' ? 'Сортировать в обратном порядке' : 'Сортировать вперёд'}
        onClick={toggleSort}
        type={'button'}
      >
        <img alt={''} src={'/images/buttons/sort-vertical-primary.svg'} />
      </MobileSortButton>
    </>
  )
}
